<template>
  <autocomplete v-model="searchQuery" :options="options" :on-item-selected="onSearchItemSelected" :on-input-change="onInputChange" :required="required">
    <template #item="props">
      <user-card :user="props.item" :with-titles="false" :with-map="false" :profile-picture="withPicture" profile-picture-size="60px" />
    </template>
  </autocomplete>
</template>

<script>
import Autocomplete from '@/components/Autocompletes/Autocomplete'

export default {
  name: 'UserAutocomplete',
  components: {
    Autocomplete
  },
  props: {
    endpoint: {
      type: String,
      default: 'users'
    },
    minCharacter: {
      type: Number,
      default: 3
    },
    required: {
      type: Boolean,
      default: false
    },
    placeholder: {
      type: String,
      default: ''
    },
    restrictToRoles: {
      type: Array,
      default: () => []
    },
    withPicture: {
      type: Boolean,
      default: true
    },
    includes: {
      type: Array,
      default: () => ['roles']
    }
  },
  data() {
    return {
      searchQuery: '',
      selectedSearchItem: null,
      options: {
        debounce: 500,
        placeholder: this.placeholder,
        inputClass: 'form-control'
      },
      currentMssgClass: 'left',
      profilePictureSize: '50'
    }
  },
  created() {
    if (!this.placeholder) {
      this.options.placeholder = this.$gettext('User Name or Email')
    }
  },
  methods: {
    onInputChange(query) {
      const params = {
        includes: this.includes,
        sort: [
          {
            key: 'name',
            direction: 'asc'
          },
          {
            key: 'id',
            direction: 'asc'
          }
        ],
        filter_groups: [
          {
            or: true,
            filters: [
              ['email', 'ct', query.trim()],
              ['name', 'ct', query.trim()]
            ]
          }
        ]
      }
      if (this.restrictToRoles.length > 0) {
        params.filter_groups.push({
          filters: [
            ['roles.name', 'in', this.restrictToRoles]
          ]
        })
      }
      if (!this.$cookies.get('bypassCountry')) {
        params.filter_groups.push(
          {
            filters: [
              ['country_iso_code', 'eq', window.country]
            ]
          }
        )
      }

      if (query.trim().length >= this.minCharacter) {
        return new Promise(resolve => {
          this.$http.get(this.$appConfig.api.baseUrl + this.endpoint, { params })
            .then(response => {
              resolve(response.body.data)
            })
        })
      }
    },
    onSearchItemSelected(item) {
      this.selectedSearchItem = item
      this.$emit('selected', item)
    }
  }
}
</script>
